// Formatação compartilhada pela tela "Meu plano"

const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

/** Valor em reais (número ou string decimal) para "R$ 199,00" */
export const formatReais = (value) => brl.format(Number(value) || 0);

/** Valor em centavos para "R$ 199,00" */
export const formatCents = (cents) => brl.format((Number(cents) || 0) / 100);

/** 'YYYY-MM-DD' -> 'DD/MM' sem passar por Date (evita virar o dia por fuso) */
export const formatDayMonth = (value) => {
  if (!value) return null;
  const [y, m, d] = String(value).slice(0, 10).split('-');
  return y && m && d ? `${d}/${m}` : null;
};

/** 'YYYY-MM-DD' -> 'DD/MM/AAAA' sem passar por Date */
export const formatDayMonthYear = (value) => {
  if (!value) return '';
  const [y, m, d] = String(value).slice(0, 10).split('-');
  return y && m && d ? `${d}/${m}/${y}` : '';
};
